export default __webpack_public_path__ + "static/media/close-modal.3fde9381.svg";